(function() {
  'use strict';

  // ============ AYARLAR ============
  const CONFIG = {
    POSET_VARIANT_ID: 43262375886938,        // ⚠️ KENDİ VARIANT ID'NİZİ YAZIN
    POSET_QUANTITY: 1,
    DEBUG: true                           // İlk testte true yapın
  };
  // =================================

  let isProcessing = false;
  let lastCheckTime = 0;
  const MIN_INTERVAL = 300; // ms - çok sık çağrı engelleme

  function log(...args) {
    if (CONFIG.DEBUG) console.log('[Poşet]', ...args);
  }

  async function getCart() {
    const res = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    });
    return res.json();
  }

  function findPoset(cart) {
    return cart.items.find(i => i.variant_id === CONFIG.POSET_VARIANT_ID);
  }

  function hasOtherItems(cart) {
    return cart.items.some(i => i.variant_id !== CONFIG.POSET_VARIANT_ID);
  }

  async function addPoset() {
    log('Poşet ekleniyor');
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: CONFIG.POSET_VARIANT_ID, quantity: CONFIG.POSET_QUANTITY }]
        })
      });
      return res.ok;
    } catch (e) {
      log('Ekleme hatası:', e);
      return false;
    }
  }

  async function changePoset(itemKey, quantity) {
    log('Poşet değiştiriliyor → adet:', quantity);
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: itemKey, quantity: quantity })
      });
    } catch (e) {
      log('Değiştirme hatası:', e);
    }
  }

  async function ensurePoset() {
    const now = Date.now();
    if (isProcessing || (now - lastCheckTime) < MIN_INTERVAL) {
      return;
    }
    isProcessing = true;
    lastCheckTime = now;

    let changed = false;

    try {
      const cart = await getCart();
      const poset = findPoset(cart);
      const others = hasOtherItems(cart);

      log('Sepet:', { items: cart.items.length, others, hasPoset: !!poset });

      if (others && !poset) {
        // Poşet eksik → ekle
        const ok = await addPoset();
        changed = ok;
      } else if (!others && poset) {
        // Sepette sadece poşet kalmış → kaldır
        await changePoset(poset.key, 0);
        changed = true;
      } else if (poset && poset.quantity > 1) {
        // Poşet adedi 1'den fazla → 1'e sabitle
        await changePoset(poset.key, 1);
        changed = true;
      }

      if (changed) {
        refreshCartUI();
      }
    } catch (e) {
      log('ensurePoset hatası:', e);
    } finally {
      isProcessing = false;
    }
  }

  function refreshCartUI() {
    log('Cart UI yenileniyor');

    // Paris teması için custom event'ler
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    
    // Pixel Union / Paris spesifik event'ler
    document.dispatchEvent(new CustomEvent('cart.requestComplete', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
    
    // jQuery event'leri (Paris jQuery kullanır)
    if (typeof window.jQuery !== 'undefined') {
      window.jQuery(document).trigger('cart.requestComplete');
      window.jQuery(document).trigger('cart:refresh');
      window.jQuery(document.body).trigger('updated_cart');
    }

    // Theme objesi varsa onun cart fonksiyonunu çağır
    if (window.theme && window.theme.cart) {
      if (typeof window.theme.cart.buildCart === 'function') {
        window.theme.cart.buildCart();
      }
      if (typeof window.theme.cart.refresh === 'function') {
        window.theme.cart.refresh();
      }
    }

    // Sepet sayfasındaysak yenile
    const path = window.location.pathname;
    if (path === '/cart' || path.endsWith('/cart')) {
      setTimeout(() => window.location.reload(), 150);
    }
  }

  // ============ EVENT YAKALAYICILAR ============

  // 1) Tüm fetch çağrılarını izle
  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const url = typeof args[0] === 'string'
        ? args[0]
        : (args[0] && args[0].url) || '';

      if (url.includes('/cart/add') ||
          url.includes('/cart/change') ||
          url.includes('/cart/update')) {
        
        // Poşet işlemini tetikleyici olarak sayma
        const body = args[1] && args[1].body;
        if (body && typeof body === 'string' &&
            body.includes(String(CONFIG.POSET_VARIANT_ID))) {
          return response;
        }

        log('Fetch yakalandı:', url);
        setTimeout(ensurePoset, 400);
      }
    } catch (e) {
      log('Fetch interceptor hatası:', e);
    }

    return response;
  };

  // 2) XMLHttpRequest izle (Paris bazı yerlerde XHR kullanır)
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this._url = url;
    return originalXHROpen.apply(this, [method, url, ...rest]);
  };

  XMLHttpRequest.prototype.send = function(body) {
    const self = this;
    this.addEventListener('load', function() {
      if (self._url && (
          self._url.includes('/cart/add') ||
          self._url.includes('/cart/change') ||
          self._url.includes('/cart/update'))) {
        if (body && String(body).includes(String(CONFIG.POSET_VARIANT_ID))) return;
        log('XHR yakalandı:', self._url);
        setTimeout(ensurePoset, 400);
      }
    });
    return originalXHRSend.apply(this, [body]);
  };

  // 3) Form submit (klasik fallback)
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    const idInput = form.querySelector('[name="id"]');
    if (idInput && parseInt(idInput.value) === CONFIG.POSET_VARIANT_ID) return;

    log('Form submit yakalandı');
    setTimeout(ensurePoset, 1000);
  });

  // 4) jQuery AJAX dinleyicisi (Paris jQuery cart kullanır)
  function setupJQueryListener() {
    if (typeof window.jQuery === 'undefined') {
      setTimeout(setupJQueryListener, 500);
      return;
    }
    
    window.jQuery(document).ajaxComplete(function(event, xhr, settings) {
      if (!settings || !settings.url) return;
      if (settings.url.includes('/cart/add') ||
          settings.url.includes('/cart/change') ||
          settings.url.includes('/cart/update')) {
        if (settings.data && String(settings.data).includes(String(CONFIG.POSET_VARIANT_ID))) return;
        log('jQuery ajax yakalandı:', settings.url);
        setTimeout(ensurePoset, 400);
      }
    });
    log('jQuery listener kuruldu');
  }
  setupJQueryListener();

  // 5) Sayfa yüklendiğinde ilk kontrol
  function init() {
    setTimeout(ensurePoset, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  log('Paris poşet script yüklendi ✓');
})();